import React from "react";
import SimpleBar from "simplebar-react";
import SidebarContent from "./SidebarContent";

const Sidebar = (props) => {
  return (
    <div className="vertical-menu">
      {props.type !== "condensed" ? (
        <SimpleBar style={{ maxHeight: "100%" }}>
          <SidebarContent />
        </SimpleBar>
      ) : (
        <SidebarContent />
      )}
      <div className="bodyoverlayWhileSetttings"></div>
    </div>
  );
};

export default Sidebar;
